import React from 'react';
import './SchoolSection.css';
import { useEffect } from 'react';
function SchoolSection() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);
  return (
    <div className="school-container">
      <div className="school-section">
        <h2 className="school-heading">School Sections</h2>

        <div className="school-subsection">
          <h3 className="school-subheading">Pre-Primary Level (Nursery, LKG, UKG)</h3>
          <p className="school-paragraph">
         
            Preschool is a preparatory school designed for children under statutory school age. It generally covers 
            children between two and five years of age. The main aim of pre-primary education is to attain optimal 
            perceptual and motor, cognitive, and socio-emotional levels as the basis for readiness for school education 
            and life in society. The focus is on the uniqueness of the child, active learning, and integration within 
            a group.
          </p>

          <h4 className="school-sublist-heading">Nursery, LKG, UKG Students' Common Subjects Include:</h4>
          <ul className="school-list">
            <li>MATHS</li>
            <li>E.V.S (Environmental Science)</li>
            <li>ENGLISH</li>
            <li>GK & CONVERSATION (General Knowledge & Conversation)</li>
          </ul>

          <h4 className="school-sublist-heading">LKG Students Additional Subjects:</h4>
          <ul className="school-list">
            <li>STORY</li>
            <li>RHYME</li>
          </ul>

          <h4 className="school-sublist-heading">UKG Students Additional Subjects:</h4>
          <ul className="school-list">
            <li>KANNADA</li>
            <li>HINDI</li>
          </ul>
        </div>

        <div className="school-subsection">
          <h3 className="school-subheading">Primary Level (Classes I – VIII)</h3>
          <p className="school-paragraph">
            Carmel Convent School cultivates five core values: honesty, kindness, respect, responsibility, and courage.
            Character development, problem-solving, and the expression of ideas, along with the acquisition of skills
            across a variety of domains, are the core focus of the Primary School. Students are taught basic lifetime
            skills such as reading, writing, spelling, interpersonal communication, and concentration. They also learn
            good study habits including:
          </p>

          <ul className="school-list">
            <li>Time management</li>
            <li>Multi-tasking and organization</li>
            <li>Short and long-term planning</li>
            <li>Test Preparation</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SchoolSection;
